import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import NoSsr from '@material-ui/core/NoSsr';
import Paper from '@material-ui/core/Paper';
import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React from 'react';
import Select from 'react-select';

const styles = withStyles((theme) => {
  const classes: StyleRules = {
    root: {
      flexGrow: 1,
      maxHeight: 250,
    },
    input: {
      display: 'flex',
      //maxHeight: 150,
      overflow: 'auto',
      height: '100%',
      padding: 0,
      width: '100%',
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      paddingLeft: 8,
    },
    chip: {
      margin: 4,
      height: 28,
      position: 'relative',
      zIndex: 100,
    },
    chipFocused: {
      backgroundColor: emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08),
    },
    noOptionsMessage: {
      padding: theme.spacing(2),
    },
    singleValue: {
      fontSize: 16,
    },
    placeholder: {
      position: 'absolute',
      left: 8,
      fontSize: 16,
    },
    paper: {
      position: 'absolute',
      left: 0,
      zIndex: 10,
      width: '100%',
    },
    divider: {
      height: theme.spacing(4),
    },
  };
  return classes;
});

class IntegrationReactSelect extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      single: null,
      multi: null,
    };
  }
  NoOptionsMessage = (props: any) => {
    return (
      <Typography color='textSecondary' className={this.props.classes.noOptionsMessage} {...props.innerProps}>
        {props.children}
      </Typography>
    );
  };

  inputComponent = ({ inputRef, ...props }: any) => {
    return <div ref={inputRef} {...props} />;
  };

  deleteChip = (event: any) => {
    this.props.removeProps && this.props.removeProps.onClick && this.props.removeProps.onClick();
    this.props.removeProps && this.props.removeProps.onMouseDown && this.props.removeProps.onMouseDown(event);
  };

  Control = (props: any) => {
    const inputComponent = this.inputComponent;
    return (
      <TextField
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          disableUnderline: true,
          inputComponent,
          inputProps: {
            className: this.props.classes.input,
            inputRef: props.innerRef,
            children: props.children,
            ...props.innerProps,
          },
        }}
        {...props.selectProps.textFieldProps}
      />
    );
  };

  Option = (props: any) => {
    return (
      <MenuItem
        buttonRef={props.innerRef}
        selected={props.isFocused}
        component='div'
        style={{
          fontWeight: props.isSelected ? 500 : 400,
        }}
        {...props.innerProps}
      >
        {props.children}
      </MenuItem>
    );
  };

  Placeholder = (props: any) => {
    return (
      <Typography color='textSecondary' className={this.props.classes.placeholder} {...props.innerProps}>
        {props.children}
      </Typography>
    );
  };

  SingleValue = (props: any) => {
    return (
      <Typography className={this.props.classes.singleValue} {...props.innerProps}>
        {props.children}
      </Typography>
    );
  };
  ValueContainer = (props: any) => {
    return <div className={this.props.classes.valueContainer}>{props.children}</div>;
  };

  MultiValue = (props: any) => {
    return (
      <Chip
        tabIndex={-1}
        label={props.children}
        className={classNames(this.props.classes.chip, {
          [this.props.classes.chipFocused]: props.isFocused,
        })}
        onDelete={this.deleteChip}
      />
    );
  };
  Menu = (props: any) => {
    return (
      <Paper square className={this.props.classes.paper} {...props.innerProps}>
        {props.children}
      </Paper>
    );
  };

  handleChange = (name: any) => (item: any) => {
    const { onChange } = this.props;
    this.setState(
      {
        [name]: item,
      },
      () => {
        if (onChange) {
          onChange(this.state.multi);
        }
      }
    );
  };

  render() {
    const { classes } = this.props;
    const components = {
      Option: this.Option,
      Control: this.Control,
      NoOptionsMessage: this.NoOptionsMessage,
      Placeholder: this.Placeholder,
      SingleValue: this.SingleValue,
      MultiValue: this.MultiValue,
      ValueContainer: this.ValueContainer,
      Menu: this.Menu,
    };

    const selectStyles = {
      input: (base: any) => ({
        ...base,
      }),
    };

    const suggestions =
      Array.isArray(this.props.options) &&
      this.props.options.map((item: any) => ({
        value: item[this.props.itemValue],
        label: item[this.props.itemLabel],
      }));
    return (
      <div className={classes.root}>
        <NoSsr>
          <Select
            id='select-multiple-component'
            styles={selectStyles}
            options={suggestions}
            components={components}
            value={this.props.value}
            onChange={this.handleChange('multi')}
            placeholder={this.props.placeholder}
            isDisabled={this.props.disabled}
            isMulti
            isLoading={this.props.loading}
            isSearchable
            closeMenuOnSelect={this.props.closeMenuOnSelect}
            maxMenuHeight={this.props.maxHeight}
            menuIsOpen={this.props.menuIsOpen}
          />
        </NoSsr>
      </div>
    );
  }
}

export default styles(IntegrationReactSelect);
